import { getMessages } from '../../../../../../../store/constants';

export const MOVE_TO_TOOLTIP = getMessages().getText('card_form_move_to_tooltip');
export const MOVE_TO_BUTTON_TITLE = getMessages().getText('card_form_move_to_button');
export const MOVE_TO_SECTION_TITLE = getMessages().getText('card_form_move_to_section_title');
export const MOVE_TO_FOLLOW = getMessages().getText('card_form_move_to_follow');
export const MOVE_TO_FOLLOW_TOOLTIP = getMessages().getText('card_form_move_to_follow_tooltip');
